import script from "./IntroductionForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./IntroductionForm.vue?vue&type=script&setup=true&lang=ts"

import "./IntroductionForm.vue?vue&type=style&index=0&id=c7401204&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7401204"]])

export default __exports__